export default __webpack_public_path__ + "static/media/refriger.5074a038.png";